@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";

web-home-funnel-entrance {
    --_postalcode-width: 120px;
    --_housenumber-width: 80px;

    &.compact {
        --_postalcode-width: 90px;
        --_housenumber-width: 60px;

        form {
            flex-direction: row;
        }
    }

    p {
        font-size: font-size.$xxs;
    }

    form {
        display: flex;
        gap: spacing.$lg;
        flex-direction: column;

        @media (min-width: breakpoints.$screen-sm-min) {
            flex-direction: row;
        }

        fieldset {
            appearance: none;
            border: 0;
            padding: 0;
            margin: 0;
        }

        input[type="text"] {
            padding: spacing.$md spacing.$md-lg spacing.$sm;

            &.postalcode {
                width: var(--_postalcode-width);
                margin-right: spacing.$sm;
            }

            &.housenumber {
                width: var(--_housenumber-width);
            }

            &::placeholder {
                color: color.$color-placeholder;
                text-transform: none;
            }
        }
    }
}
